export function storeLIFFData() {
  const currentUrl = new URL(window.location.toString())
  if (currentUrl.searchParams.get('lineLiffToken')) {
    sessionStorage.setItem('line_liff_token', currentUrl.searchParams.get('lineLiffToken'))
  }

  if (currentUrl.searchParams.get('redirectUrlFromLiff')) {
    sessionStorage.setItem(
      'line_liff_redirect_url',
      currentUrl.searchParams.get('redirectUrlFromLiff')
    )
  }
}
